import { render, staticRenderFns } from "./ButtonToggleSideBar.vue?vue&type=template&id=a9f11872&scoped=true&"
import script from "./ButtonToggleSideBar.vue?vue&type=script&lang=js&"
export * from "./ButtonToggleSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f11872",
  null
  
)

export default component.exports